export default (): void => {
  const unsubscribers: Array<() => void> = []

  window.onDomLoad(function ($dom) {
    const doc = $dom[0]

    unsubscribers.forEach((unsubscriber) => unsubscriber())

    const eventDrivenPrepareTab = doc.querySelector(
      "[data-behaviour='event-driven-prepare-tab']"
    ) as HTMLAnchorElement

    function updatePrepareTabUrl(url: string): void {
      // Update the href so that it can open with right click
      if (eventDrivenPrepareTab) {
        eventDrivenPrepareTab.href = url
      }
    }

    if (eventDrivenPrepareTab) {
      window.eventHub.$on('prepare-tab-url-updated', updatePrepareTabUrl)
      unsubscribers.push(() => {
        window.eventHub.$off('prepare-tab-url-updated', updatePrepareTabUrl)
      })
    }
  })
}
